var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showState,
      expression: "showState"
    }],
    staticClass: "g_pop g_pop_loading"
  }, [_c('div', {
    staticClass: "pop_wrap"
  }, [_c('div', {
    staticClass: "pop_con"
  }, [_c('i', {
    staticClass: "icon_loading"
  }), _vm.msg ? _c('p', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.msg))]) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };